import { AssetFields } from '../Asset/query';
export const InlineImageFields = `
{
    image ${AssetFields()}
    text
}
`;
